import React from "react";
import Checkbox from "material-ui/Checkbox";

const RowCheckbox = ({ value, state, changeHandler, key, disabled }) => {
  return (
    <React.Fragment key={key}>
      <Checkbox
        checked={state === true ? true : false}
        onChange={changeHandler}
        value={`${value}`}
        disabled={disabled}
        draggable={true}
      />
    </React.Fragment>
  );
};

export default RowCheckbox;
